export class CommonResponse<T = any> {
  data?: T;
  message!: string;
  errors?: any;
  statusCode!: number;

  isAdmin?: boolean;
}